/**
 * System Diagnostics Page
 * This page provides diagnostic tools for system administrators
 */
import React from 'react';
import { 
  Container, 
  Grid, 
  Card, 
  CardHeader, 
  CardContent,
  Typography,
  Tabs,
  Tab,
  Box
} from '@mui/material';
import AwsRekognitionDiagnostic from '../components/AwsRekognitionDiagnostic';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const DiagnosticsPage = () => {
  const { user } = useAuth();
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Only admin users can access this page
  if (!user || user.permissionLevel !== 'admin') {
    return <Navigate to="/unauthorized" />;
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>System Diagnostics</Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange}
              aria-label="diagnostics tabs"
            >
              <Tab label="AWS Services" />
              <Tab label="Azure Storage" />
              <Tab label="Database" />
              <Tab label="API Services" />
            </Tabs>
          </Box>
          
          <TabPanel value={tabValue} index={0}>
            <Typography variant="h5" sx={{ mb: 3 }}>AWS Service Diagnostics</Typography>
            <AwsRekognitionDiagnostic />
            <Card sx={{ mb: 4 }}>
              <CardHeader title="Additional AWS Services" />
              <CardContent>
                <Typography color="textSecondary">
                  Additional AWS service diagnostics will be added here in the future.
                </Typography>
              </CardContent>
            </Card>
          </TabPanel>
          
          <TabPanel value={tabValue} index={1}>
            <Typography variant="h5" sx={{ mb: 3 }}>Azure Storage Diagnostics</Typography>
            <Card sx={{ mb: 4 }}>
              <CardHeader title="Azure Blob Storage" />
              <CardContent>
                <Typography color="textSecondary">
                  Azure Storage diagnostic tools will be added here.
                </Typography>
              </CardContent>
            </Card>
          </TabPanel>
          
          <TabPanel value={tabValue} index={2}>
            <Typography variant="h5" sx={{ mb: 3 }}>Database Diagnostics</Typography>
            <Card sx={{ mb: 4 }}>
              <CardHeader title="MongoDB Connection" />
              <CardContent>
                <Typography color="textSecondary">
                  Database diagnostic tools will be added here.
                </Typography>
              </CardContent>
            </Card>
          </TabPanel>
          
          <TabPanel value={tabValue} index={3}>
            <Typography variant="h5" sx={{ mb: 3 }}>API Service Diagnostics</Typography>
            <Card sx={{ mb: 4 }}>
              <CardHeader title="API Health Check" />
              <CardContent>
                <Typography color="textSecondary">
                  API service health check tools will be added here.
                </Typography>
              </CardContent>
            </Card>
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
};

// TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`diagnostics-tabpanel-${index}`}
      aria-labelledby={`diagnostics-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

export default DiagnosticsPage;
